<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label tag="div">Ano</label>
          <b-form-input
            type="text"
            placeholder="Ano"
            v-model="form.ano"
            name="ano"
            v-mask="mascaraAno"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('ano')"
            v-if="form.errors.has('ano')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label tag="div">Dia (DD/MM)</label>
          <b-form-input
            type="text"
            placeholder="Dia"
            v-model="form.diaMes"
            name="dia"
            v-mask="mascaraDia"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('dia')"
            v-if="form.errors.has('dia')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <label tag="div">Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>
      <b-row>
        <b-col>
          <label>Status</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.status"
              :options="this.$parent.optionsStatus"
              name="status"
              plain
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Feriado Anual</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.feriado_anual"
              :options="this.$parent.optionsFeriadoAnual"
              plain
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('feriado_anual')"
            v-if="form.errors.has('feriado_anual')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <label tag="div">Tipo do Feriado</label>
      <multiselect
        v-model="tpFeriadoSelected"
        :options="this.$parent.optionsTpFeriado"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder=""
        select-label=""
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('tp_feriado')"
        v-if="form.errors.has('tp_feriado')"
      ></b-form-feedback>
      <b-row>
        <b-col>
          <label tag="div">Municipio</label>
          <multiselect
            v-model="municipioSelected"
            :options="this.$parent.optionsMunicipio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
            :disabled="this.form.tp_feriado == 1 || this.form.tp_feriado == 2"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('tp_feriado')"
            v-if="form.errors.has('tp_feriado')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label tag="div">Uf</label>
          <multiselect
            v-model="ufSelected"
            :options="this.$parent.optionsUf"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
            :disabled="this.form.tp_feriado == 1"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('tp_feriado')"
            v-if="form.errors.has('tp_feriado')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      mascaraDia: "##/##",
      mascaraAno: "####",
      municipioSelected: [],
      ufSelected: [],
      tpFeriadoSelected: [],
      errors_array: [],
      form: new Form({
        ano: "",
        diaMes: "",
        descr: "",
        status: "",
        feriado_anual: "",
        tp_feriado: "",
        municipio_id: "",
        uf_id: "",
        feriado_id: ""
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    municipioSelected(obj) {
      this.form.municipio_id = obj.value;
    },
    ufSelected(obj) {
      this.form.uf_id = obj.value;
    },
    tpFeriadoSelected(obj) {
      if(obj.value==1){
        this.ufSelected = [];
        this.municipioSelected = [];
      }
      if(obj.value==2){
        this.municipioSelected = [];
      }
      this.form.tp_feriado = obj.value;
    }
  },
  mounted() {
    this.getLivStatus();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.feriado_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.form.reset();
      this.tpFeriadoSelected = [];
      this.municipioSelected = [];
      this.ufSelected = [];
      this.tpFeriadoSelected = this.$parent.optionsTpFeriado[2];
      this.form.status = 1;
      this.form.feriado_anual = 2;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.municipioSelected = [];
      this.ufSelected = [];
      this.tpFeriadoSelected = [];
      this.form.feriado_id = data.feriado_id;
      this.form.ano = data.ano;
      this.form.diaMes = data.dia + "/" + data.mes;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.feriado_anual = data.feriado_anual.valor;
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor
      };
      if (data.rel_feriado_uf != null) {
        this.ufSelected = {
          label: data.rel_feriado_uf.uf.nome,
          value: data.rel_feriado_uf.uf.uf_id
        };
      }
      if (data.rel_feriado_municipio != null) {
        this.ufSelected = {
          label: data.rel_feriado_municipio.municipio.uf.nome,
          value: data.rel_feriado_municipio.municipio.uf.uf_id
        };
        this.municipioSelected = {
          label: data.rel_feriado_municipio.municipio.nome,
          value: data.rel_feriado_municipio.municipio.municipio_id
        };
      }
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor
      };
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/feriado/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/feriado/status")
        .then(response => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    getLivStatus() {
      this.helpForm.params = { tabela: this.tabela, coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsLivStatus.push({ text: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
